import { ReactNode } from 'react';
import { useLang } from 'hooks/lang';

import { Column } from 'components/Blocks';
import { CircleAlertIcon } from 'components/Icons';

interface NotFoundProps {
  children: ReactNode;
  render: boolean;
}

export function NoInvoiceFound({ children, render }: NotFoundProps): JSX.Element {
  const { t } = useLang();

  if (!render) return <>{children}</>;

  return (
    <Column fullHeight justifyContent="center" gap="2" alignItems="center">
      <CircleAlertIcon color="primary" size={48} />

      <span className="text-2xl font-medium">{t('no-invoice-was-found-for-this-status')}</span>
    </Column>
  );
}
